import { render } from "./ChatWindowComp.vue?vue&type=template&id=7b5172c1&scoped=true"
import script from "./ChatWindowComp.vue?vue&type=script&lang=js"
export * from "./ChatWindowComp.vue?vue&type=script&lang=js"

import "./ChatWindowComp.vue?vue&type=style&index=0&id=7b5172c1&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5172c1"]])

export default __exports__